import { render, staticRenderFns } from "./LandingPagesIcon.vue?vue&type=template&id=cbe2d1d2&scoped=true"
import script from "./LandingPagesIcon.vue?vue&type=script&lang=js"
export * from "./LandingPagesIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe2d1d2",
  null
  
)

export default component.exports